import { render, staticRenderFns } from "./VSuggestSettlement.vue?vue&type=template&id=e63cfa8e&scoped=true"
import script from "./VSuggestSettlement.vue?vue&type=script&lang=js"
export * from "./VSuggestSettlement.vue?vue&type=script&lang=js"
import style0 from "./VSuggestSettlement.vue?vue&type=style&index=0&id=e63cfa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63cfa8e",
  null
  
)

export default component.exports